import type { SVGProps } from "react";
import { Ref, forwardRef, memo } from "react";
const SvgMaterialSymbolsOpenInNew = (
  props: SVGProps<SVGSVGElement>,
  ref: Ref<SVGSVGElement>
) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    viewBox="0 0 24 24"
    ref={ref}
    {...props}
  >
    <path
      fill="currentColor"
      d="M5 21q-.825 0-1.412-.587T3 19V5q0-.825.588-1.412T5 3h7v2H5v14h14v-7h2v7q0 .825-.587 1.413T19 21zm4.7-5.3-1.4-1.4L17.6 5H14V3h7v7h-2V6.4z"
    />
  </svg>
);
const ForwardRef = forwardRef(SvgMaterialSymbolsOpenInNew);
const Memo = memo(ForwardRef);
export default Memo;
